import {
  type EnvironmentDescriptor,
  resolveEnvironment,
  selectableEnvironments,
} from '../utils/environment'

export interface UseEnvironment {
  current: EnvironmentDescriptor
  environments: EnvironmentDescriptor[]
}

export function useEnvironment(): UseEnvironment {
  const { hostname } = useRequestURL()
  return {
    current: resolveEnvironment(hostname),
    environments: selectableEnvironments,
  }
}
